__turbopack_context__.v({
  "barChart": "analytics-module__HSNMPa__barChart",
  "barCount": "analytics-module__HSNMPa__barCount",
  "barFill": "analytics-module__HSNMPa__barFill",
  "barItem": "analytics-module__HSNMPa__barItem",
  "barLabel": "analytics-module__HSNMPa__barLabel",
  "barName": "analytics-module__HSNMPa__barName",
  "barRank": "analytics-module__HSNMPa__barRank",
  "barWrapper": "analytics-module__HSNMPa__barWrapper",
  "chartCard": "analytics-module__HSNMPa__chartCard",
  "container": "analytics-module__HSNMPa__container",
  "emptyState": "analytics-module__HSNMPa__emptyState",
  "exportBtn": "analytics-module__HSNMPa__exportBtn",
  "header": "analytics-module__HSNMPa__header",
  "insightCard": "analytics-module__HSNMPa__insightCard",
  "insightText": "analytics-module__HSNMPa__insightText",
  "insightTitle": "analytics-module__HSNMPa__insightTitle",
  "insightsGrid": "analytics-module__HSNMPa__insightsGrid",
  "metricCard": "analytics-module__HSNMPa__metricCard",
  "metricIcon": "analytics-module__HSNMPa__metricIcon",
  "metricLabel": "analytics-module__HSNMPa__metricLabel",
  "metricValue": "analytics-module__HSNMPa__metricValue",
  "metricsGrid": "analytics-module__HSNMPa__metricsGrid",
  "section": "analytics-module__HSNMPa__section",
  "sectionTitle": "analytics-module__HSNMPa__sectionTitle",
  "subtitle": "analytics-module__HSNMPa__subtitle",
  "title": "analytics-module__HSNMPa__title",
});
